var _defs, _path, _rect, _line, _line2, _line3, _line4, _line5, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke-width:2px;}.cls-1{stroke:#0090b9;}.cls-1,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#b3ddee;}.cls-3{stroke:#b3ddee;}.cls-4{fill:#0090b9;stroke:#fff;stroke-width:0.5px;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.83,29.07H142.24a3.81,3.81,0,0,1,3.81,3.81v51a5.48,5.48,0,0,1-5.48,5.48H34.83A3.81,3.81,0,0,1,31,85.51V32.88A3.81,3.81,0,0,1,34.83,29.07Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.34,
    y: 35.47,
    width: 19.22,
    height: 16.66
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.06,
    y1: 57.43,
    x2: 109.06,
    y2: 57.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.06,
    y1: 63.67,
    x2: 109.06,
    y2: 63.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.06,
    y1: 69.83,
    x2: 109.06,
    y2: 69.83
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.57,
    y1: 36.07,
    x2: 59.17,
    y2: 36.07
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.57,
    y1: 41.07,
    x2: 59.17,
    y2: 41.07
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.88 62.4 29.77 66.75 23.6 75.88 19.25 65.77 10.12 59.6 20.23 55.24 26.4 46.12 30.75 56.23 39.88 62.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.72 88.26 120.86 91.65 116.07 98.74 112.69 90.88 105.6 86.09 113.45 82.7 118.24 75.61 121.63 83.47 128.72 88.26"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "115.96 26.86 112.3 28.44 110.06 31.74 108.49 28.08 105.19 25.85 108.85 24.27 111.08 20.97 112.66 24.63 115.96 26.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail3);
export default __webpack_public_path__ + "static/media/mail3.c38cec5eeb2da5403a59571e2ab8714c.svg";
export { ForwardRef as ReactComponent };